import { render, staticRenderFns } from "./dnamobile.vue?vue&type=template&id=699397be&"
import script from "./dnamobile.vue?vue&type=script&lang=js&"
export * from "./dnamobile.vue?vue&type=script&lang=js&"
import style0 from "./dnamobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports